export default "__VITE_ASSET__CrAYTtFz__"